// extracted by mini-css-extract-plugin
export default {"container":"t7d4_P","viewer":"AFrwsw","truncated":"USlpga","expandTransition":"I6Vh23","shrinkTransition":"emVBzv","showMore":"LxhQTT"};